var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPngSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32x",
    height: "32px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 318.188 318.188",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E8E8E8"
    },
    points: "227.321,7.5 40.342,7.5 40.342,310.688 277.846,310.688 277.846,58.025  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 98.402,
    y: 69.204,
    style: {
      fill: "#FFFFFF"
    },
    width: 29.973,
    height: 29.972
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.375,
    y: 69.204,
    style: {
      fill: "#D1D3D3"
    },
    width: 29.972,
    height: 29.972
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.347,
    y: 69.204,
    style: {
      fill: "#FFFFFF"
    },
    width: 29.973,
    height: 29.972
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.319,
    y: 69.204,
    style: {
      fill: "#D1D3D3"
    },
    width: 29.973,
    height: 29.972
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 188.318,
    y: 99.176,
    style: {
      fill: "#FFFFFF"
    },
    width: 29.973,
    height: 29.972
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.347,
    y: 99.176,
    style: {
      fill: "#D1D3D3"
    },
    width: 29.972,
    height: 29.972
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.374,
    y: 99.176,
    style: {
      fill: "#FFFFFF"
    },
    width: 29.973,
    height: 29.972
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.401,
    y: 99.176,
    style: {
      fill: "#D1D3D3"
    },
    width: 29.973,
    height: 29.972
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 98.402,
    y: 129.148,
    style: {
      fill: "#FFFFFF"
    },
    width: 29.973,
    height: 29.972
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.375,
    y: 129.148,
    style: {
      fill: "#D1D3D3"
    },
    width: 29.972,
    height: 29.972
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.347,
    y: 129.148,
    style: {
      fill: "#FFFFFF"
    },
    width: 29.973,
    height: 29.972
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.319,
    y: 129.148,
    style: {
      fill: "#D1D3D3"
    },
    width: 29.973,
    height: 29.972
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 188.318,
    y: 159.12,
    style: {
      fill: "#FFFFFF"
    },
    width: 29.973,
    height: 29.972
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.347,
    y: 159.12,
    style: {
      fill: "#D1D3D3"
    },
    width: 29.972,
    height: 29.972
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.374,
    y: 159.12,
    style: {
      fill: "#FFFFFF"
    },
    width: 29.973,
    height: 29.972
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.401,
    y: 159.12,
    style: {
      fill: "#D1D3D3"
    },
    width: 29.973,
    height: 29.972
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#007934"
    },
    points: "192.295,130.178 168.483,170.358 129.743,104.984 98.402,157.872 98.402,189.093  218.292,189.093 218.292,174.049  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#38A3FF"
    },
    points: "235.14,32.763 40.342,32.763 40.342,7.5 227.321,7.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D3D3"
    },
    points: "227.321,58.025 277.846,58.025 227.321,7.5  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M283.149,52.722L232.625,2.197C231.218,0.79,229.311,0,227.321,0H40.342c-4.143,0-7.5,3.358-7.5,7.5 v303.188c0,4.142,3.357,7.5,7.5,7.5h237.504c4.143,0,7.5-3.358,7.5-7.5V58.025C285.346,56.036,284.556,54.129,283.149,52.722z  M234.821,25.606l24.918,24.919h-24.918L234.821,25.606L234.821,25.606z M47.842,15h171.979v10.263H47.842V15z M270.346,303.188 H47.842V40.263h171.979v17.763c0,4.142,3.357,7.5,7.5,7.5h43.024v237.662H270.346z M165.994,255.084 c0,2.932,0.152,6.815,0.459,11.65h-0.196l-17.459-33.343h-16.934v47.979h11.486v-21.627c0-2.8-0.209-6.859-0.624-12.175h0.296 l17.524,33.802h16.999v-47.979h-11.552L165.994,255.084L165.994,255.084z M207.181,263.289h8.565v7.515 c-1.619,0.373-3.392,0.558-5.316,0.558c-3.523,0-6.219-1.176-8.09-3.528c-1.87-2.352-2.806-5.771-2.806-10.256 c0-4.572,1.033-8.089,3.102-10.551c2.067-2.461,4.993-3.692,8.778-3.692c4.135,0,7.931,0.854,11.388,2.56l4.103-10.174 c-1.991-0.875-4.327-1.597-7.007-2.166c-2.681-0.568-5.53-0.853-8.549-0.853c-7.964,0-14.156,2.155-18.575,6.465 c-4.419,4.311-6.629,10.338-6.629,18.083c0,7.942,2.019,14.058,6.055,18.345c4.037,4.288,9.752,6.432,17.147,6.432 c6.738,0,12.919-0.962,18.542-2.888v-25.86h-20.708V263.289z M119.655,237.363c-3.041-2.647-7.592-3.971-13.651-3.971H89.397 v47.979h12.963v-15.917h3.644c5.819,0,10.31-1.46,13.472-4.381c3.161-2.92,4.742-7.061,4.742-12.421 C124.218,243.773,122.696,240.01,119.655,237.363z M109.368,253.247c-1.149,1.094-2.697,1.641-4.645,1.641h-2.363v-11.026h3.348 c3.588,0,5.383,1.619,5.383,4.857C111.091,250.643,110.517,252.153,109.368,253.247z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPngSvgrepoCom);
export default __webpack_public_path__ + "static/media/png-svgrepo-com.5dd0da31.svg";
export { ForwardRef as ReactComponent };